import { useState, useEffect } from 'react';

/**
 * Hook that detects device orientation using the browser's matchMedia API.
 * More reliable than window.innerWidth > window.innerHeight which can be
 * wrong when the keyboard is open or on unusual aspect ratios.
 *
 * Returns { isLandscape, isPortrait } — updates in real time on rotation.
 */
const useOrientation = () => {
  const [isLandscape, setIsLandscape] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(orientation: landscape)').matches;
  });

  useEffect(() => {
    const mq = window.matchMedia('(orientation: landscape)');

    const handler = (e) => setIsLandscape(e.matches);

    // Modern browsers + Safari < 14 fallback
    if (mq.addEventListener) {
      mq.addEventListener('change', handler);
    } else {
      mq.addListener(handler);
    }

    setIsLandscape(mq.matches);

    return () => {
      if (mq.removeEventListener) {
        mq.removeEventListener('change', handler);
      } else {
        mq.removeListener(handler);
      }
    };
  }, []);

  return { isLandscape, isPortrait: !isLandscape };
};

export default useOrientation;
